import { Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import { RoutalLoader, VSpacer } from '@nx-smartmonkey/ui';
import { useRetrieveFlatProjects } from '../../hooks/project/useRetrieveFlatProjects';
import { useRetrieveUser } from '../../hooks/user/useRetrieveUser';

import Text from '../../react-components/Text';

const styles = {
  container: {
    height: `100vh`,
    width: `100%`,
  },
};

type NoProjectsProps = {
  classes: {
    container: string;
  };
};

const NoProjects = ({ classes }: NoProjectsProps) => {
  const { data: user } = useRetrieveUser();
  const { data: projects } = useRetrieveFlatProjects({ user });

  const isLoadingProjects = projects?.length === 0;

  if (isLoadingProjects) {
    return (
      <Grid
        container
        justifyContent="center"
        style={{ height: `100%`, backgroundColor: `#e9e9e9` }}
        alignItems="center"
      >
        <Grid container justifyContent="center" style={{ width: `200px`, height: `200px` }}>
          <RoutalLoader />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid className={classes.container} direction="column" container justifyContent="center" alignItems="center">
      <>
        <Grid item>
          <Text variant="h6" intlId="projects.not_assigned_projects.title" />
        </Grid>

        <VSpacer />

        <Grid item>
          <Text intlId="projects.not_assigned_projects.info" />
        </Grid>

        {/* <Grid container justifyContent="center">
          <img src={logoblack} alt="" className={classes.logo}></img>
        </Grid> */}
      </>
    </Grid>
  );
};

export default withStyles(styles)(NoProjects);
